export enum Role {
	USER = "USER",
	ADMIN = "ADMIN",
	GLOBAL_ADMIN = "GLOBAL_ADMIN",
}
